import { useEffect, useState } from 'react';
import { useGoodsSno } from '../../../hooks/useGoodsSno';
import { useLogGoodsAnalyticsEvent } from '../../../hooks/useLogGoodsAnalyticsEvent';

export const useLogViewGoodsOptionModal = (params: {
  mode: 'purchase' | 'gift';
  isShowOnce: boolean;
}) => {
  const sno = useGoodsSno();
  const logGoodsAnalytics = useLogGoodsAnalyticsEvent();

  const [isLogged, setIsLogged] = useState(false);
  useEffect(() => {
    if (isLogged) return;
    if (params.isShowOnce) return;

    logGoodsAnalytics({
      name: 'VIEW_GOODS_OPTION_MODAL',
      analytics: {
        ...(params.mode === 'gift'
          ? { KIND: 'GIFT', FROM_BUTTON: '' }
          : { FROM_BUTTON: 'PURCHASE_BUTTON' }),
      },
    });

    setIsLogged(true);
  }, [isLogged, logGoodsAnalytics, params.isShowOnce, params.mode, sno]);
};
